var _style, _defs, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClients(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000035516217365074856900000011476001124674775176_);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 16,
    height: 16
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000112595433180366631240000011775547091640822941_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000112595433180366631240000011775547091640822941_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.9,5.1c0,0.3-0.2,0.6-0.5,0.7L8.4,8.8C8.2,8.9,8,8.9,7.8,8.8L0.7,5.8C0.4,5.6,0.3,5.4,0.3,5.1 c0-0.3,0.2-0.6,0.5-0.7l7.1-3.1c0.2-0.1,0.4-0.1,0.6,0l7.1,3.1C15.7,4.5,15.9,4.8,15.9,5.1z M8.1,2.8L2.9,5.1l5.2,2.3l5.2-2.3 L8.1,2.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15,4.2c0.4,0,0.8,0.3,0.8,0.8v4c0,0.4-0.3,0.8-0.8,0.8c-0.4,0-0.8-0.3-0.8-0.8V5C14.3,4.6,14.6,4.2,15,4.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.8,6v5c0,0.2,0.1,0.5,0.8,0.8C6.1,12,7,12.2,8,12.2s1.9-0.2,2.5-0.5c0.6-0.3,0.8-0.6,0.8-0.8V6h1.5v5 c0,1-0.8,1.7-1.6,2.1c-0.9,0.4-2,0.7-3.2,0.7s-2.3-0.2-3.2-0.7C4,12.7,3.2,12,3.2,11V6H4.8z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.41c9e7e597b1ace9a78dd45abab5c9f7.svg";
export { ForwardRef as ReactComponent };